import React from 'react';

import scss from './Video.module.scss';

function Video({ item, onError }) {
  const handleError = () => {
    onError?.(item);
  };

  return (
    <video
      src={item.preview}
      alt={item.name}
      onError={handleError}
      onErrorCapture={handleError}
      className={scss.video}
      controls
      preload='metadata'
      loading='lazy'>
      <track kind='captions' />
    </video>
  );
}

export default Video;
